// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsCon {
  width: 1200px;
  margin: 0px auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 30px;
}
.newsCon .title {
  text-align: center;
  font-size: 22px;
  padding: 0px 50px;
}
.newsCon .time {
  text-align: center;
  color: #666;
  font-size: 14px;
}
.newsCon-con {
  line-height: 30px;
  font-size: 16px;
  padding: 20px 30px;
}
.newsCon-con p {
  text-indent: 20px;
}
.newsCon-con img {
  max-width: calc(100% - 40px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/New/index.less"],"names":[],"mappings":"AAAA;EAAS,aAAA;EAAc,gBAAA;EAAiB,sBAAA;EAAuB,mBAAA;EAAsB,mBAAA;AAMrF;AANA;EACU,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;AAU/C;AAXA;EAES,kBAAA;EAAoB,WAAA;EAAY,eAAA;AAczC;AAbG;EAAM,iBAAA;EAAmB,eAAA;EAAiB,kBAAA;AAkB7C;AAlBG;EACK,iBAAA;AAoBR;AArBG;EAEO,4BAAA;AAsBV","sourcesContent":[".newsCon{width:1200px; margin:0px auto; border:1px solid #ddd; border-radius: 10px;  margin-bottom:30px;\n   .title{text-align: center; font-size: 22px; padding:0px 50px;}\n   .time{text-align: center; color:#666; font-size:14px; }\n   &-con{line-height: 30px; font-size: 16px; padding:20px 30px;\n      p{text-indent: 20px;}\n      img{max-width:calc(100% - 40px);}\n   }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
